// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TermsSigine_QEBw2 {
  margin-top: 10px;
  top: 5px;
  position: relative;
  width: 100%;
  height: auto;
  padding: 10px;
  background-color: #f7c5c5;
}
.serviceName_xrTYD {
  text-align: left;
  margin-left: 10px;
}
.serviccNumInput_Xaq32 {
  width: 70%;
}
.textAreaWide_kayt8 {
  width: 50%;
  margin-left: 15px;
}
.datePicker_GH7k4 {
  position: relative;
  width: 100%;
}
.enableService_bz2a_ {
  align-self: right;
  text-align: right;
  color: #175ca9;
  right: 0;
  cursor: pointer;
  position: relative;
}
.right_alignButtonIcon_EX0tZ {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.controlItemWidth_XsrZM {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Clients/RegisteredClients/Partnership/Buttons/Compliance/compliance.less"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;AACJ;AASA;EACI,gBAAA;EACA,iBAAA;AAPJ;AAUA;EACI,UAAA;AARJ;AAWA;EACI,UAAA;EACA,iBAAA;AATJ;AAgBA;EACI,kBAAA;EACA,WAAA;AAdJ;AAiBA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;AAfJ;AA4BA;EACI,aAAA;EACA,8BAAA;EACA,WAAA;AA1BJ;AA4BA;EACI,WAAA;AA1BJ","sourcesContent":[".TermsSigine {\n    margin-top: 10px;\n    top: 5px;\n    position: relative;\n    width: 100%;\n    height: auto;\n    padding: 10px;\n    background-color: #f7c5c5;\n}\n\n// .serviceItem {\n//     display: flex;\n//     justify-content: space-between;\n//     align-items: left;\n//     margin-bottom: 10px;\n// }\n\n.serviceName {\n    text-align: left;\n    margin-left: 10px;\n}\n\n.serviccNumInput {\n    width: 70%;\n}\n\n.textAreaWide {\n    width: 50%;\n    margin-left: 15px;\n}\n\n// .datePickerLeft {\n//     margin-top: 10px;\n// }\n\n.datePicker {\n    position: relative;\n    width: 100%;\n}\n\n.enableService {\n    align-self: right;\n    text-align: right;\n    color: #175ca9;\n    right: 0;\n    cursor: pointer;\n    position: relative;\n}\n\n// // .totalbox {\n// //     margin-top: 20px;\n// //     margin-bottom: 20px;\n// // }\n\n// // .serviceSwitch {\n// //     margin-top: 20px !important;\n// //     margin-bottom: 20px !important;\n// // }\n\n.right_alignButtonIcon {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n.controlItemWidth {\n    width: 100%;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TermsSigine": `TermsSigine_QEBw2`,
	"serviceName": `serviceName_xrTYD`,
	"serviccNumInput": `serviccNumInput_Xaq32`,
	"textAreaWide": `textAreaWide_kayt8`,
	"datePicker": `datePicker_GH7k4`,
	"enableService": `enableService_bz2a_`,
	"right_alignButtonIcon": `right_alignButtonIcon_EX0tZ`,
	"controlItemWidth": `controlItemWidth_XsrZM`
};
export default ___CSS_LOADER_EXPORT___;
